import { render, staticRenderFns } from "./ComplaintsTable.vue?vue&type=template&id=ed08d4ae&scoped=true"
import script from "./ComplaintsTable.vue?vue&type=script&lang=js"
export * from "./ComplaintsTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsTable.vue?vue&type=style&index=0&id=ed08d4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed08d4ae",
  null
  
)

export default component.exports